export default __webpack_public_path__ + "static/media/Button-Carousel-Back.88b5f336.svg";